import { ArrowRight, Phone } from "lucide-react";

export default function CTASection({ onRequestDemo }) {
  return (
    <section
      id="contact"
      data-testid="cta-section"
      className="py-32 lg:py-40 px-6 lg:px-12 text-center"
    >
      <div className="max-w-3xl mx-auto reveal">
        <p
          className="text-xs tracking-[0.3em] uppercase mb-6"
          style={{ color: "#D4AF37", fontFamily: "'Manrope', sans-serif", fontWeight: 600 }}
        >
          Transform Your Practice
        </p>
        <h2
          className="text-4xl sm:text-5xl lg:text-6xl tracking-tight font-light text-white leading-tight mb-8"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Elevate Your<br />
          <span className="gold-text">Aesthetic Offering</span>
        </h2>
        <p
          className="text-base text-white/40 max-w-xl mx-auto leading-relaxed tracking-wide mb-12"
          style={{ fontFamily: "'Manrope', sans-serif" }}
        >
          Experience the convergence of every leading RF microneedling technology
          in one masterful device. Schedule a personalized demonstration today.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={onRequestDemo}
            className="gold-btn px-10 py-4 text-xs tracking-[0.2em] uppercase flex items-center gap-3"
            data-testid="cta-request-demo-btn"
          >
            Request a Demo
            <ArrowRight size={14} />
          </button>
          <a
            href="tel:+18187937558"
            className="outline-btn px-10 py-4 text-xs tracking-[0.2em] uppercase flex items-center gap-3 no-underline"
            data-testid="cta-contact-btn"
          >
            <Phone size={14} />
            Contact Sales
          </a>
        </div>

        <div className="gold-line w-16 mx-auto mt-16" />
      </div>
    </section>
  );
}
